import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable()
export class AppLoadService {
    serviceName = environment.serviceName;

    constructor() {}

    async getSettings() {
        const settings: any = {}; // await this.httpClient.post(`${this.serviceName}/api/utility/applicationSettings`, {}).toPromise();
        return settings;
    }
}
